import script from "./Payload_Mapping_Create_Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Payload_Mapping_Create_Edit.vue?vue&type=script&setup=true&lang=js"

import "./Payload_Mapping_Create_Edit.vue?vue&type=style&index=0&id=97ecbe68&lang=css"

const __exports__ = script;

export default __exports__